import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserManager } from 'oidc-client';
import { getAuthKeys } from './api';
import { AuthKeys } from './interfaces';

interface AuthState {
  value: AuthKeys[] | null;
  isLoading: boolean;
  error: string | null;
  updatedWithKeys: boolean;
}

export const initialState: AuthState = {
  value: null,
  isLoading: false,
  error: null,
  updatedWithKeys: false,
};

function startLoading(state: AuthState) {
  state.isLoading = true;
}

export const fetchAuthKeys = createAsyncThunk('fetchAuthKeys', async (prefix: string) => {
  return await getAuthKeys(prefix);
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserManager(state, action: PayloadAction<UserManager>) {
      state.updatedWithKeys = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAuthKeys.pending, startLoading);
    builder.addCase(fetchAuthKeys.fulfilled, (state, { payload }) => {
      state.value = payload;
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(fetchAuthKeys.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || 'Fetching auth keys failed';
    });
  },
});

export const { setUserManager } = authSlice.actions;

export default authSlice.reducer;
